module.exports = __webpack_public_path__ + "static/media/status_error.433cb4e3.svg";